import { faRankingStar, faTrophy } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import type { ReactElement } from 'react'
import { Loader } from '~/components/Global/Elements/Loader/Loader'
import { NoResult } from '~/components/Global/Elements/NoResult/NoResult'
import { AsideAction } from '~/components/Scopes/Actions/AsideAction'
import { formatDateShort } from '~/utils/date'
import { useShortlistReport } from '../queries/shortlistReport'
import {
  answerTag,
  podiumTrophy,
  reportComment,
  reportLine,
  reportLineHeader,
  reportList,
  reportRank,
  reportSubtitle
} from './ShortlistReport.css'

type ShortlistReportAsideProps = {
  shortlistId: number
}

export const ShortlistReportAside = ({
  shortlistId
}: ShortlistReportAsideProps): ReactElement => {
  const {
    data: report,
    isLoading,
    isError
  } = useShortlistReport(shortlistId, true)

  const subtitle = [
    report?.contactName,
    report?.submittedAt
      ? `le ${formatDateShort(new Date(report.submittedAt))}`
      : null
  ]
    .filter(Boolean)
    .join(' · ')

  return (
    <AsideAction title="Retour de présentation client" icon={faRankingStar}>
      {isLoading && <Loader small />}
      {isError && (
        <NoResult
          isError
          message="Le retour du contact n'a pas pu être chargé."
        />
      )}
      {report && (
        <>
          {subtitle && <div className={reportSubtitle}>{subtitle}</div>}
          <div className={reportList}>
            {report.applicants.map((line) => (
              <div key={line.applicantId} className={reportLine}>
                <div className={reportLineHeader}>
                  {line.rank === 1 || line.rank === 2 || line.rank === 3 ? (
                    <FontAwesomeIcon
                      icon={faTrophy}
                      className={podiumTrophy[line.rank]}
                      title={`${line.rank}${line.rank === 1 ? 'er' : 'e'}`}
                    />
                  ) : (
                    <span className={reportRank}>{line.rank}</span>
                  )}
                  <span>
                    {line.firstname} {line.lastname}
                  </span>
                  {line.accepted !== null && (
                    <span className={answerTag[line.accepted ? 'yes' : 'no']}>
                      {line.accepted ? 'Retenu' : 'Non retenu'}
                    </span>
                  )}
                </div>
                {line.comment && (
                  <div className={reportComment}>{line.comment}</div>
                )}
              </div>
            ))}
          </div>
        </>
      )}
    </AsideAction>
  )
}
